module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Publisher: Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Art Director/Cover Designer: Kristy Zacharias")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editor: Lynn Koolish")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editors: Debbie Rodgers and Mary E. Flynn")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book Designer: Casey Dukes")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinator/Illustrator: Jenny Davis")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Editor: Katie Van Amburg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photo Assistant: Mary Peyton Peppo")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Styled photos by Nissa Brehmer, unless otherwise noted; Instructional photos by Diane Pedersen, unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by Stash Books, an imprint of C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e48b3c40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copyright.vue
// module id = 60
// module chunks = 0